"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionMatching = exports.REGION_BY_INPUT = void 0;
const fuse_js_1 = __importDefault(require("fuse.js"));
const regions_1 = require("./regions");
exports.REGION_BY_INPUT = regions_1.REGIONS.flatMap((region) => [
    { input: region.name, region },
    ...region.places.map((place) => ({
        input: place,
        region,
    })),
]);
const REGION_MATCH_OPTIONS = {
    keys: ["input"],
    isCaseSensitive: false,
    includeScore: true,
    threshold: 0.3,
};
const REGION_MATCHER = new fuse_js_1.default(exports.REGION_BY_INPUT, REGION_MATCH_OPTIONS);
function getRegionMatching(input) {
    var _a;
    const regionOnly = input
        .trim()
        .replace(/  +/g, " ")
        .replace(/^(Co(unty|\.)?( of)? |City of )/i, "")
        .replace(/ (Village|Town|City|County)$/i, "")
        .replace(/[^A-Za-zÀ-ÖØ-öø-ÿ \-']/g, "");
    const match = REGION_MATCHER.search(regionOnly);
    if (((_a = match === null || match === void 0 ? void 0 : match[0]) === null || _a === void 0 ? void 0 : _a.item) !== undefined) {
        return match[0].item.region;
    }
    return undefined;
}
exports.getRegionMatching = getRegionMatching;
